import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import {useGetSegmentTags} from "../../../apis/requests/templates/getSegmentTags";
import {FieldLabel, FormCard} from "./FormCard";
import PromoSegmentsSelect from "./PromoSegmentsSelect";
import {PromoFormValues} from "./schema";

const ELIGIBILITY_HINT =
  "A user is eligible if they are in any of the selected segments. Evaluated at user level on the primary account.";

const EligibilityCard = () => {
  const {control} = useFormContext<PromoFormValues>();
  const {data: segments = []} = useGetSegmentTags();

  return (
    <FormCard title="Eligibility" hint={ELIGIBILITY_HINT}>
      <div>
        <FieldLabel required>Segments</FieldLabel>
        <Controller
          name="segment_ids"
          control={control}
          render={({field}) => (
            <PromoSegmentsSelect segments={segments} value={field.value} onChange={field.onChange} />
          )}
        />
      </div>
    </FormCard>
  );
};

export default EligibilityCard;
